import React from "react";
import { globalBgCss } from "../styles.js";

export function BackgroundManager() {
  return (
    <style>
      {globalBgCss}
    </style>
  );
} 